export default __webpack_public_path__ + "static/media/melanie-lim-SkMBbB9gjQc-unsplash_2.f06c2773.jpg";